module.exports = "/packs/images/sprites/cruk~9d4c5235ea19bf9ac780062851e1f9c3.png";